import { render, staticRenderFns } from "./StandardizationVerification.vue?vue&type=template&id=54ca606c&"
import script from "./StandardizationVerification.vue?vue&type=script&lang=js&"
export * from "./StandardizationVerification.vue?vue&type=script&lang=js&"
import style0 from "./StandardizationVerification.vue?vue&type=style&index=0&id=54ca606c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports